// product-ticker.js
(function() {
  const rows = document.querySelectorAll('.product-ticker__row');

  if (rows.length === 0) return;

  // Calculate scroll position and update animation progress
  function updateTickers() {
    const scrollY = window.scrollY;
    const windowHeight = window.innerHeight;
    const docHeight = document.documentElement.scrollHeight;

    // Calculate overall scroll progress (0 to 1)
    const scrollProgress = scrollY / (docHeight - windowHeight);

    rows.forEach((row, index) => {
      const track = row.querySelector('.product-ticker__track');
      const direction = row.dataset.direction;
      let trackWidth = track.offsetWidth / 3; // Divide by 3 because we repeat 3 times
      const viewportWidth = window.innerWidth;
      let movement = scrollProgress * trackWidth * 2;

      // Calculate movement based on scroll
      if (viewportWidth < 768) {
        movement = scrollProgress * trackWidth * 3.5;

      } else {
        movement = scrollProgress * trackWidth * 2;

      }
      // Multiply for more movement

      if (direction === 'ltr') {
        track.style.transform = `translateX(-${movement}px)`;
      } else {
        track.style.transform = `translateX(-${trackWidth - movement}px)`;
      }
    });
  }

  // Throttle scroll events
  let ticking = false;
  window.addEventListener('scroll', () => {
    if (!ticking) {
      window.requestAnimationFrame(() => {
        updateTickers();
        ticking = false;
      });
      ticking = true;
    }
  });

  // Initial update
  updateTickers();
})();
